import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';

/**
 * Hook to get service display name for preset group columns.
 * Returns the rate shopper name if set, otherwise falls back to fixed service name.
 * @param {string} serviceId - The fixed service ID
 * @param {string} rateShopperGuid - The rate shopper/service collection GUID
 * @returns {{ name: string, isTemplate: boolean }} The display name and whether it's a template
 */
const useServiceColumnDisplay = (serviceId, rateShopperGuid) => {
  const sellerServices = useSelector((state) => Global.selectSellergetShippingServices(state));
  const serviceCollections = useSelector(Global.selectSellerServiceCollections);

  // Check for rate shopper first
  if (rateShopperGuid) {
    const serviceCollection = serviceCollections.find((collection) => collection.serviceCollectionGuid === rateShopperGuid);
    if (serviceCollection) {
      return { name: serviceCollection.name, isTemplate: serviceCollection.isTemplate };
    }
    return { name: '', isTemplate: false };
  }

  // Fall back to fixed service
  const sellerService = sellerServices[serviceId];
  if (!sellerService) {
    return { name: '', isTemplate: false };
  }
  return { name: sellerService.name, isTemplate: false };
};

export default useServiceColumnDisplay;
